<a href="javascript:void(0)" (click)="loadProductDetail()" class="btn-link" porAddFeature featureName="items-out-detail-button" [dynamicValue]="cellValue">
    {{ cellValue }}
</a>
